var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaradviseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.888 4.97l-.008.007H.92l.273.719 2.695-.727zm0 0h2.52a4.338 4.338 0 00-.102.148l-.003.004-.017.016-.013.02c-.207.32-.378.672-.508 1.057-.484 1.423-.406 2.802.24 4.087.687 1.37 1.788 2.192 3.257 2.425h0c1.126.178 2.165-.011 3.077-.57.748-.46 1.283-1.094 1.581-1.885l1.567 1.43c-.898 1.596-2.153 2.539-3.845 2.9a7.702 7.702 0 01-1.608.173 7 7 0 01-2.012-.293 6.334 6.334 0 01-2.262-1.224c-1.173-.984-1.92-2.23-2.226-3.706a7.726 7.726 0 01-.14-2.276l.024-.25-.078.001v-.002h-.224a2.06 2.06 0 01-1.923-1.33l2.695-.726z",
    fill: "#282828",
    stroke: "#282828",
    strokeWidth: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.172 3.242h7.71c.637 0 1.29.148 1.94.437a3.352 3.352 0 011.824 1.908l1.895-1.748a5.606 5.606 0 00-2.06-1.965c-.781-.435-1.656-.706-2.677-.827A10.013 10.013 0 009.672 1H0l.322.849a2.176 2.176 0 001.85 1.394",
    fill: "#282828"
  })));
}
export default __webpack_public_path__ + "static/media/caradvise_icon.5c74104a.svg";
export { SvgCaradviseIcon as ReactComponent };